export default __webpack_public_path__ + "static/google-logo-f69dce0ceac0afb8266cb6c442e6ca71.svg";